import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, List, Popconfirm, Spin, Tag } from "antd";
import { observer } from "mobx-react";
import { useCallback, useState } from "react";
import { refreshQueue } from "@devowl-wp/real-queue";
import { ScannerAllExternalUrlsTable } from "./allExternalUrls/table.js";
import { ScannerExternalUrlActionPopover } from "./externalUrlActionPopover.js";
import { useStores } from "../../../store/stores.js";
import { __, _n } from "../../../utils/i18n.js";
const ScannerListItem = observer(({ item })=>{
    const [expanded, setExpanded] = useState(false);
    const { data: { host, foundOnSitesCount, tags, ignored }, inactive, blockedStatus, blockedStatusText, busy } = item;
    const { scannerStore } = useStores();
    const toggleExpandExternalUrls = useCallback(()=>{
        setExpanded(!expanded);
    }, [
        host,
        expanded
    ]);
    const scanAllAgain = useCallback(async ()=>{
        const allSourceUrls = [];
        try {
            await scannerStore.fetchResultAllExternals(item);
            scannerStore.resultAllExternalUrls.get(item.data.host).forEach((item)=>{
                allSourceUrls.push(item.data.sourceUrl);
            });
            await scannerStore.addUrlsToQueue({
                urls: allSourceUrls,
                purgeUnused: false
            });
            await Promise.all([
                scannerStore.fetchResultExternals(),
                refreshQueue()
            ]);
        } catch (e) {
            if (e instanceof Error) {
                console.log(e);
            }
        }
    }, [
        item
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(List.Item, {
                itemID: host,
                actions: [
                    /*#__PURE__*/ _jsx(ScannerExternalUrlActionPopover, {
                        item: item
                    }, "handle"),
                    ignored && /*#__PURE__*/ _jsx("a", {
                        onClick: ()=>{
                            item.ignore(false);
                            setExpanded(false);
                        },
                        children: __("Show recommendation again")
                    }),
                    !inactive && /*#__PURE__*/ _jsx(Popconfirm, {
                        title: __("Are you sure that you want to ignore this recommendation?"),
                        placement: "bottomRight",
                        onConfirm: ()=>{
                            item.ignore(true);
                            setExpanded(false);
                        },
                        okText: __("Ignore recommendation"),
                        cancelText: __("Cancel"),
                        overlayStyle: {
                            maxWidth: 350
                        },
                        children: /*#__PURE__*/ _jsx("a", {
                            children: __("Ignore recommendation")
                        })
                    }, "delete")
                ].filter(Boolean),
                style: {
                    opacity: inactive && !expanded ? 0.6 : 1
                },
                children: /*#__PURE__*/ _jsx(Spin, {
                    spinning: busy,
                    children: /*#__PURE__*/ _jsx(List.Item.Meta, {
                        title: /*#__PURE__*/ _jsxs("span", {
                            children: [
                                host,
                                " ",
                                tags.map((tag)=>/*#__PURE__*/ _jsx(Tag, {
                                        children: `<${tag} />`
                                    }, tag)),
                                ignored && /*#__PURE__*/ _jsx(Tag, {
                                    children: __("Ignored")
                                }),
                                blockedStatus !== "none" && /*#__PURE__*/ _jsx(Tag, {
                                    color: blockedStatus === "partial" ? "warning" : "success",
                                    children: blockedStatusText
                                })
                            ]
                        }),
                        description: /*#__PURE__*/ _jsx("button", {
                            className: "button-link",
                            onClick: toggleExpandExternalUrls,
                            children: expanded ? __("Close") : _n("Embeds found on %d page", "Embeds found on %d pages", foundOnSitesCount, foundOnSitesCount)
                        })
                    })
                })
            }),
            expanded && /*#__PURE__*/ _jsx(ScannerAllExternalUrlsTable, {
                instance: item,
                reload: expanded && foundOnSitesCount > 0,
                reloadDependencies: [
                    expanded,
                    foundOnSitesCount
                ],
                style: {
                    marginTop: "-6px"
                },
                tableProps: {
                    footer: ()=>/*#__PURE__*/ _jsx("div", {
                            style: {
                                textAlign: "right"
                            },
                            children: /*#__PURE__*/ _jsx(Button, {
                                onClick: scanAllAgain,
                                children: __("Scan these pages again")
                            })
                        })
                }
            })
        ]
    });
});
export { ScannerListItem };
